angular.module('gym.calendar').controller('RescheduleSingleEventCtrl', ["$scope", "$modalInstance", "flash", "ConfirmLeaveUnsavedChangesService", "params", function($scope, $modalInstance, flash, ConfirmLeaveUnsavedChangesService, params) {
  var dateTimeToDate, dateToTime, mergeDateAndTime;
  $scope.event = params.event;
  $scope.frequencyUpdateParams = {
    change_type: 'reschedule_single_event',
    change_attributes: {}
  };
  dateTimeToDate = function(dt) {
    return moment(dt, 'YYYY/MM/DD HH:mm').toDate();
  };
  dateToTime = function(d) {
    return moment(d).format('HH:mm:ss');
  };
  mergeDateAndTime = function(d, t) {
    return `${d} ${dateToTime(t)}`;
  };
  $scope.formData = {
    event_date: $scope.event.event_date,
    start_at: dateTimeToDate($scope.event.start_at),
    end_at: dateTimeToDate($scope.event.end_at),
    previous_start_at: dateTimeToDate($scope.event.start_at)
  };
  ConfirmLeaveUnsavedChangesService.watch($scope, 'frequencyUpdateParams', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  $scope.onChange = function() {
    var base, base1, date, diff, end_at, start_at;
    (base = $scope.formData).start_at || (base.start_at = moment().toDate());
    (base1 = $scope.formData).end_at || (base1.end_at = moment().toDate());
    diff = moment($scope.formData.start_at).diff($scope.formData.previous_start_at, 'minutes');
    $scope.formData.previous_start_at = $scope.formData.start_at;
    if (diff) {
      $scope.formData.end_at = moment($scope.formData.end_at).add(diff, 'minutes').toDate();
    }
    date = $scope.formData.event_date;
    start_at = $scope.formData.start_at;
    end_at = $scope.formData.end_at;
    return $scope.frequencyUpdateParams.change_attributes = {
      start_at: mergeDateAndTime(date, start_at),
      end_at: mergeDateAndTime(date, end_at)
    };
  };
  $scope.isFormReady = function() {
    return !$scope.isLoading;
  };
  return $scope.save = function() {
    $scope.isLoading = true;
    return params.save($scope.frequencyUpdateParams).then(function() {
      return $scope.close(true);
    }, function() {
      return $scope.isLoading = false;
    });
  };
}]);
